import React from "react";
import { RepetitionType, SummaryRow } from "../../__generated__/graphql";
import type { Meta, StoryObj } from "@storybook/react";
import PayrollBreakdownSummary from "../../screens/client/PayrollBreakdownSummary";

const ROWS_PRESETS: SummaryRow[] = [
    {
        category: "bonus",
        description: "Gros bonus",
        productKey: "bonus",
        quantity: 1,
        unitPrice: 77700,
    },
    {
        productKey: "fee_other",
        category: "dynamic_fee",
        description: "Chaussettes",
        repetition: RepetitionType.Count,
        quantity: 1,
        unitPrice: 6000,
    },
    {
        category: "dynamic_fee",
        description: "Trajet à Martigny",
        productKey: "fee_other",
        repetition: RepetitionType.Count,
        quantity: 3,
        unitPrice: 2500,
    },
    {
        category: "dynamic_fee",
        description: "Trajet professionnel",
        productKey: "fee_other",
        repetition: RepetitionType.WorkedDay,
        quantity: 2,
        unitPrice: 4000,
    },
    {
        category: "dynamic_fee",
        description: "Abonnement téléphone",
        productKey: "fee_other",
        repetition: RepetitionType.WorkedMonth,
        quantity: 2,
        unitPrice: 5000,
    },
    {
        category: "effective_fee",
        description: "Disque dur SSD",
        productKey: "fee_other",
        quantity: 1,
        unitPrice: 13000,
    },
    {
        category: "effective_fee",
        description: "Chaussures de ski",
        productKey: "fee_other",
        quantity: 1,
        unitPrice: 12000,
    },
    {
        category: "deduction",
        description: "Repas de midi",
        productKey: "fee_other",
        quantity: 21,
        unitPrice: -1000,
    },
];

const StoryComponent = ({ salaryRows = [] }: { salaryRows: SummaryRow[] }) => {
    return <PayrollBreakdownSummary rows={[...salaryRows, ...ROWS_PRESETS]} loading={false} />;
};

const meta = {
    title: "Screens/PayrollBreakdownSummary",
    component: StoryComponent,
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const SalaryMonthlyFull: Story = {
    args: {
        salaryRows: [
            {
                category: "salary",
                productKey: "salary_monthly_full",
                quantity: 1,
                unitPrice: 654300,
            },
        ],
    },
};

export const SalaryMonthlyPartial: Story = {
    args: {
        salaryRows: [
            {
                category: "salary",
                productKey: "salary_monthly_partial",
                quantity: 1,
                unitPrice: 432100,
            },
            {
                category: "salary",
                productKey: "salary_overtime_0",
                quantity: 30,
                unitPrice: 2000,
            },
            {
                category: "salary",
                productKey: "salary_overtime_25",
                quantity: 20,
                unitPrice: 500,
            },
            {
                category: "salary",
                productKey: "salary_overtime_50",
                quantity: 10,
                unitPrice: 1000,
            },
        ],
    },
};

export const SalaryDaily: Story = {
    args: {
        salaryRows: [
            {
                category: "salary",
                productKey: "salary_daily",
                quantity: 1,
                unitPrice: 50000,
            },
            {
                category: "salary",
                productKey: "salary_overtime_25",
                quantity: 20,
                unitPrice: 500,
            },
            {
                category: "salary",
                productKey: "salary_overtime_50",
                quantity: 10,
                unitPrice: 1000,
            },
        ],
    },
};

export const SalaryHourly: Story = {
    args: {
        salaryRows: [
            {
                category: "salary",
                productKey: "salary_hourly",
                quantity: 1,
                unitPrice: 6000,
            },
            {
                category: "salary",
                productKey: "salary_overtime_25",
                quantity: 20,
                unitPrice: 500,
            },
            {
                category: "salary",
                productKey: "salary_overtime_50",
                quantity: 10,
                unitPrice: 1000,
            },
        ],
    },
};

export const SalaryPackage: Story = {
    args: {
        salaryRows: [
            {
                category: "salary",
                productKey: "salary_package",
                quantity: 1,
                unitPrice: 123400,
            },
            {
                category: "salary",
                productKey: "salary_overtime_25",
                quantity: 20,
                unitPrice: 500,
            },
            {
                category: "salary",
                productKey: "salary_overtime_50",
                quantity: 10,
                unitPrice: 1000,
            },
        ],
    },
};
